import {useState} from 'react';
import {useSelector, useStore} from 'react-redux';
import {MentionEditor} from '~/ViewInvitation/common/mention-editor';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {editPostComment, postReply} from '../../../reducers/apiActions';
import {selectPost} from '../../../reducers/posts';
import './comment-editor.sass';

export const CommentEditor = (props) => {
  const {
    postIdOfComment,
    handleClearComment,
    isEditingComment,
    editingIsFinished,
    handleCommentClose,
    shouldClearComment,
    hideClear,
    dataQaId,
    id,
    parentPostId,
  } = props;
  const store = useStore();

  const [commentToPost, setCommentToPost] = useState('');
  const [clearComment, setClearComment] = useState(false);
  const stickyHeader = document.querySelector('.whos-coming__sticky-header');

  const currentComment = useSelector((state) => {
    if (isEditingComment) {
      const post = selectPost(postIdOfComment);
      const postState = post(state);
      return postState.comment;
    }
    return '';
  });

  const handleOnChange = (value) => {
    setCommentToPost(value);
  };

  const handleCommentSubmit = () => {
    isEditingComment
      ? store.dispatch(editPostComment(postIdOfComment, commentToPost))
      : store.dispatch(postReply(parentPostId, commentToPost));

    if (editingIsFinished) editingIsFinished();
    if (handleCommentClose) handleCommentClose();
    if (stickyHeader) evite.removeClass(stickyHeader, 'unstick');
    if (shouldClearComment) setClearComment(true);
  };

  const handleFocus = () => {
    document.querySelector(`#${id}`).focus();
    if (stickyHeader) evite.addClass(stickyHeader, 'unstick');
  };

  return (
    <div className="comment-editor__wrap">
      <div className="comment-editor">
        <MentionEditor
          placeholder="Add a comment"
          singleLineInput={false}
          onChange={handleOnChange}
          autoFocus
          onFocus={handleFocus}
          initialContent={currentComment || ''}
          clearFromParent={!!clearComment}
          handleCommentSubmit={handleCommentSubmit}
          dataQaId={dataQaId}
          id={id}
        />
      </div>

      {!hideClear && (
        <button
          onClick={handleClearComment}
          type="button"
          className="unstyled-button"
          data-qa-id="close-comment-editor"
        >
          <CloseLineIcon ratio={0.75} />
        </button>
      )}
    </div>
  );
};
